import React from 'react'
import Button from '../components/Button'
import EmailForm from '../components/EmailForm'
//import HubspotForm from 'react-hubspot-form'
//import './hubspotform.js'

class StartPage extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: 0,
      hubspotSubmit: false,
    }
  }
  static defaultProps = {
    setWrapperState: () => {},
  }
  onNext() {
    var nextPage = this.props.data.nextPageIndex
    if (typeof nextPage === 'object') {
      nextPage = nextPage[this.state.selected - 1]
    }
    const toUpdate = this.props.data.propUpdated
      ? this.props.data.propUpdated
      : 'temp'
    this.setState({ selected: 0 })
    this.props.setWrapperState({
      currPage: nextPage,
      [toUpdate]: this.state.selected,
    })
  }

  onBack() {
    const { prevPageIndex, prevPageDecider } = this.props.data
    this.setState({ selected: 0 })
    if (typeof prevPageIndex === 'number') {
      this.props.setWrapperState({
        currPage: prevPageIndex,
      })
    } else {
      const prevPagePos = this.props.wrapperState[prevPageDecider]
      this.props.setWrapperState({
        currPage: prevPageIndex[prevPagePos - 1],
      })
    }
  }

  enabledNext(data) {
    const { selected, hubspotSubmit } = this.state
    if (!data.showHubSpot || selected === 2) {
      return selected !== 0
    }
    return hubspotSubmit
  }

  successSubmit(message) {
    alert(message)
    this.setState({ hubspotSubmit: true })
  }

  //Heres the hubspot code, in case we ever revert to it
  //  <HubspotForm
  //   portalId={data.hubsportPortalID}
  //   formId={data.hubsportFormID}
  //   onSubmit={() => this.setState({hubspotSubmit: true})}
  //   onReady={(form) => {}}
  //   loading={<div>Loading...</div>}
  // />

  render() {
    const { selected } = this.state
    const { data } = this.props
    return (
      <div style={{textAlign: 'center'}}>
        <div className="hero">
          <h3>Find the right aesthetic treatment for you</h3>
          <p>With all the non-invasive treatments available today, we’re here to help you find the best options that are right for you. Take this quick and easy quiz to discover the top Venus Treatments that suit your unique needs and fit your busy lifestyle.</p>
        </div>
        {data.showHubSpot && selected === 1 && (
          <div className="hubspotForm">
            <EmailForm
              data={this.props.data}
              onSubmitSuccess={() => this.successSubmit(data.success)}
              wrapperState={this.props.wrapperState}
              summaryContent={this.props.summaryContent}
            />
          </div>
        )}
            <Button
            className="startButton quiz-button quiz-button-blue quiz-button-round"
              shape="round"
              variant="blue"
              onClick={() => this.onNext()}
            >
              {data.nextButton}
            </Button>
      </div>
    )
  }
}

export default StartPage
